import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import ConsumerPageWrapper from 'bundles/unified-description-page-common/pages/consumer/ConsumerPageWrapper';

const GoogleCoursePageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/consumer/course/GoogleCoursePageRoot')
);

const GoogleSpecializationPageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/consumer/specialization/GoogleSpecializationPageRoot')
);

export default (
  <Route>
    <CourseraRoute
      path="/"
      component={ConsumerPageWrapper}
      handle={{
        tracking: {
          segment: 'consumer',
        },
      }}
    >
      {['google-certificates/:productSlug', ':subfolderLocaleCode/google-certificates/:productSlug'].map((path) => (
        <CourseraRoute
          key={path}
          path={path}
          getComponent={GoogleSpecializationPageRoot}
          handle={{
            tracking: {
              data: () => ({
                page: {
                  type: 'xdp_google_cert',
                },
              }),
            },
          }}
        />
      ))}
      {['google-learn/:productSlug', ':subfolderLocaleCode/google-learn/:productSlug'].map((path) => (
        <Route
          key={path}
          path={path}
          getComponent={GoogleCoursePageRoot}
          handle={{
            tracking: {
              data: () => ({
                page: {
                  type: 'xdp_google_course',
                },
              }),
            },
          }}
        />
      ))}
      {['google-specializations/:productSlug', ':subfolderLocaleCode/google-specializations/:productSlug'].map(
        (path) => (
          <Route
            key={path}
            path={path}
            getComponent={GoogleSpecializationPageRoot}
            handle={{
              tracking: {
                data: () => ({
                  page: {
                    type: 'xdp_google_s12n',
                  },
                }),
              },
            }}
          />
        )
      )}
    </CourseraRoute>
    <Route path="*" component={NotFound} />
  </Route>
);
